import API from "../config/api.js";

export const EmployerService = {

  createEmployer(data) { 
    return API.post(`api/employer/create`, data);
  },

  updateEmployer1(uuid, data) { 
    return API.post(`api/employer/update/google/${uuid}`, data);
  },

  createEmployer1(data) { 
    return API.post(`api/employer/create1`, data);
  },

  getRolesList() {
    return API.get(`api/employer/roles`);
  },

  getEmployerInfo() {
    return API.get(`api/employer/profile`);
  },

  uploadEmployerProfilePic(data) {
    return API.post(`api/employer/profile-image/upload`, data);
  },

  updateEmployer(data) {
    return API.post(`api/employer/update`, data);
  },

  googleVerify(data) {
    return API.post(`api/google/verify`, data);
  },

  getEmployerList(search, page) {
    return API.get(`api/employer/list/se=${search}?page=${page}`);
  },

  getEmployerInfoByUuid(uuid) {
    return API.get(`api/employer/info/${uuid}`);
  },

  updateEmployerById(id,data) {
    return API.post(`api/employer/update-by/${id}`,data);
  },
  
  dropMember(uuid) {
    return API.post(`api/employer/delete/${uuid}`);
  },

  updateEnableAuth(){
    return API.get(`api/enableAuth/active`);
  },

  updateEnableAuth1(){
    return API.get(`api/enableAuth/deactive`);
  },

  getSpecialities() {
    return API.get(`api/employer/speciality`);
  },


  
};